import { render } from "./AuditReport.vue?vue&type=template&id=52d1f9d8&scoped=true"
import script from "./AuditReport.vue?vue&type=script&lang=js"
export * from "./AuditReport.vue?vue&type=script&lang=js"

import "./AuditReport.vue?vue&type=style&index=0&id=52d1f9d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d1f9d8"]])

export default __exports__